import { MemberProfile } from '@/modules/members/types'

export type AgreementSimple = {
    id: string,
    name: string
}

export type Organization = {
    id: string,
    businessId: string,
    logoUrl: null|string,
    companyName: string,
    isSsoOn: boolean,
    contactName: string,
    contactEmail: string,
    ssoAgreementId: string,
    vatId: string,
    customerNumber: string,
    memberCount: number,
    ssoReportingDimensions: boolean
}

export type OrganizationsListModel = Organization

export type GetOrganizationsList = {
    count: number,
    results: OrganizationsListModel[]
}

export type OrganizationsSimplifiedListModel = {
    id: string,
    companyName: string
}

export type AddOrganization = Pick<Organization, 'companyName' | 'businessId' > & {
    contactPersonName: string,
    contactPersonEmail: string
}

export type ChangeOrganizationName = {
    organizationId: string,
    companyName: string
}

export type ChangeOrganizationContactPerson = {
    organizationId: string,
    contactPersonName: string,
    contactPersonEmail: string,
}

export type ChangeOrganizationLogoURL = {
    logoUrl: string|null,
}

export type ChangeOrganizationBusinessId = {
    businessId: string,
}

export type ChangeOrganizationDomainName = {
    organizationId: string,
    domainName: string,
}

export type OrganizationMembersListResponse = {
    count: number,
    results: MemberProfile[]
}

export type AddMemberToOrganization = {
    memberId: string,
    organizationId: string
}

export type DeleteMemberFromOrganization = {
    memberId: string,
    organizationId: string
}

export enum ValidityResultType {
    INVALID = 0,
    VALID = 1,
    FAKE = 2
}

export type MembersProfilesUpdateModel = {
    message: string,
    rowNumber: number,
    success: boolean,
    email: string
}

export type ChangeOrganizationIndustry = {
    organizationId: string,
    industryId: string | null
}
